<template>
  <div style="background-color:#1a181c; margin-top:auto; width:100%;">
    <div class="container pt-40 color-fff">
      <b-row>
        <b-col lg="4">
          <div class="block mb-40">
            <div class="b-title pl-20 fs-16 bold mb-20">{{ $t("pagebottom.sponsor") }}</div>
            <a
              v-for="(v, i) in list1"
              :key="i"
              class="pl-20 fs-14 mb-20 link"
              :href="v.url"
              target="_blank"
              >{{ v.name }}
            </a>
          </div>
        </b-col>
        <b-col lg="4">
          <div class="block mb-40">
            <div class="b-title pl-20 fs-16 bold mb-20">{{ $t("pagebottom.organizers") }}</div>
            <a
              v-for="(v, i) in list2"
              :key="i"
              class="pl-20 fs-14 mb-20 link"
              :href="v.url"
              target="_blank"
              >{{ v.name }}
            </a>
          </div>
        </b-col>
        <!-- <b-col lg="3">
          <div class="block mb-40">
            <div class="b-title pl-20 fs-16 bold mb-20 mt-custom"></div>
            <a
              v-for="(v, i) in list3"
              :key="i"
              class="pl-20 fs-14 mb-20 link"
              :href="v.url"
              target="_blank"
              >{{ v.name }}
            </a>
          </div>
        </b-col> -->
        <b-col lg="4">
          <div class="block mb-40">
            <div class="b-title pl-20 fs-16 bold mb-20">{{ $t("pagebottom.executive") }}</div>
            <a
              class="pl-20 fs-14 mb-20 link"
              href="https://expounion.com.cn/"
              target="_blank"
              >{{ $t("pagebottom.executive1") }}
            </a>
          </div>
        </b-col>
      </b-row>
      <footer class="fs-14 pt-30 pb-30">
        <div class="nav mb-bottom">
          <a v-for="(v, i) in nav" :key="i" @click="toFriend(v.url)"
            >
            <div class="flex-container nav_item">
              <span>{{ v.name }}</span>
              <!-- <span>{{ v.en }}</span> -->
            </div>
            <!-- <span class="ml-20 mr-20" v-if="i < 3">|</span> -->
          </a>
        </div>
        <div class="copyright  clearfix">
          <div style="color:#999;">
            {{ $t("pagebottom.copyright") }}
          </div>
          <a target="_blank" href="https://beian.miit.gov.cn/"
            >&nbsp;粤ICP备17092841号-4</a
          >
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/utils/bus.js";
export default {
  data() {
    return {
      list1: [
        { name:  this.$t("pagebottom.sponsor1"), url: "http://www.cftc.org.cn/cn/" },
        { name:  this.$t("pagebottom.sponsor2"), url: "http://cmif.mei.net.cn/" },
        {
          name: this.$t("pagebottom.sponsor4"),
          url: "http://auto-ccpit.org/",
        },
        { name:  this.$t("pagebottom.sponsor3"), url: "http://www.caam.org.cn/" },
      ],
      list2: [
        {
          name: this.$t("pagebottom.organizers1"),
          url: "http://www.fairwindow.com/cn/index.html",
        },
        {
          name: this.$t("pagebottom.organizers8"),
          url: "http://auto-ccpit.org/",
        },
        {
          name: this.$t("pagebottom.organizers2"),
          url: "https://www.gac.com.cn/",
        },
        { name: this.$t("pagebottom.organizers3"), url: "http://www.sae-china.org/" },
        { name: this.$t("pagebottom.organizers4"), url: "#" },
        {
          name: this.$t("pagebottom.organizers5"),
          url: "http://www.gzccpit.org.cn/index.do",
        },
        { name: this.$t("pagebottom.organizers6"), url: "http://www.gzqxasa.cn/" },
        { name: this.$t("pagebottom.organizers7"), url: "http://www.giee.org.cn/" },
      ],
      list3: [
        {
          name: this.$t("pagebottom.organizers5"),
          url: "http://www.gzccpit.org.cn/index.do",
        },
        // { name: this.$t("pagebottom.organizers6"), url: "http://www.gzasa.org/" },
        // { name: this.$t("pagebottom.organizers7"), url: "http://www.giee.org.cn/" },
         { name:  this.$t("pagebottom.sponsor1"), url: "http://www.cftc.org.cn/cn/" },
        { name: this.$t("pagebottom.organizers9"), url: "http://www.sae-china.org/" },
        { name: this.$t("pagebottom.organizers10"), url: "https://www.gacbusiness.com.cn/" },
        
      ],
      nav: [
        {
          name: this.$t("pagebottom.contact"),
          en: "Contact Us",
          url: "/friendlyLink?tab=0",
        },
        {
          name: this.$t("pagebottom.link"),
          en: "Link",
          url: "/friendlyLink?tab=2",
        },
        {
          name: this.$t("pagebottom.announcement"),
          en: "Announcement",
          url: "/friendlyLink?tab=1",
        },
        {
          name: this.$t("pagebottom.guide"),
          en: "Website Guide",
          url: "/friendlyLink?tab=3",
        },
      ],
    };
  },
  methods: {
    toFriend(url) {
      EventBus.$emit('resetNavActiveIndex',-1)
      this.$router.push({ path: url });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-footer {
  border-top: 2px solid;
  background-color: #1a181c;
}

a {
  position: relative;
  display: block;
  color: #999999;
  cursor: pointer;
}
.copyright {
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav {
  display: flex;
  justify-content: center;
  align-items: center;
  .nav_item{
    margin-right: 20px;
    margin-left: 20px;
    padding-right: 20px;
    border-right: 1px solid #999;
  
  }
  // .nav_item:after{
  //   content: "";
  //   width: 1px;
  //   height: 14px;
  //   background: #999;
  // }
  a:last-child .nav_item{
    border:none;
  }
  
}
@media screen and (min-width: 100px) and (max-width: 1000px) {
  .mb-bottom {
    margin-bottom: 90px;
  }
  .mt-custom {
    margin-top: 0px;
  }
  footer {
    text-align: center;
    flex-direction: column;
    border-top: 2px solid #999;
  }

  .link {
    &::after {
      content: "·";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      color: #999999;
      font-size: 60px;
    }
  }
  .b-title {
    position: relative;
    &::after {
      position: absolute;
      left: 0;
      top: 40%;
      transform: translateY(-40%);
      content: "";
      width: 12px;
      height: 80%;
      background: #fff;
      border-radius: 5px;
    }
  }
}
@media screen and (min-width: 1000px) and (max-width: 2560px) {
  .mt-custom {
    margin-top: 40px;
  }
  footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid #999;
  }
  .link {
    &::after {
      content: "·";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      color: #999999;
      font-size: 20px;
    }
  }
  .b-title {
    position: relative;
    &::after {
      position: absolute;
      left: 0;
      top: 40%;
      transform: translateY(-40%);
      content: "";
      width: 6px;
      height: 80%;
      background: #fff;
      border-radius: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// pageFooter.vue?4f8188bb